import React from 'react'

class PublishOverlay extends React.Component {
  render () {
    return <div id='publish'>Publish overlay...</div>
  }
}

module.exports = PublishOverlay
